export default "__VITE_ASSET__DyeKMb8W__"